import React from 'react';


const tecno = [
    { T: 'Bootstrap', L: 'https://getbootstrap.com/' },
    { T: 'Python', L: 'https://www.python.org/' },
    { T: 'MySql', L: 'https://www.mysql.com/' },
    { T: 'HTML', L: 'https://www.w3schools.com/html/' },
    { T: 'CSS', L: 'https://www.w3schools.com/css/' },

];


class Gameover extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>GameOverWeb</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <iframe src="https://www.youtube.com/embed/OMgYyvn_Rew" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This website is set to the gaming world, it allows you to create users, profiles and upload posts about your favorite video games.</p>
                        <a href="https://github.com/BrandonGrimaldoM/gameoverweb" target="_blank" rel="noreferrer">
                        <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Gameover;